import React from "react";
import { Row, Col } from "react-bootstrap";
import "./leaveManagment.css";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "reactstrap";

const Personalinfo = (props) => {
	return (
		<div className="personalInfo">
			{props.empInfo ? (
				<div className="info-header">
					<h2>Personal Information</h2>
				</div>
			) : (
				<div className="info-header">
					<h2>Emergency Contact</h2>
					{!props.submitButtonEnable ? (
						<i
							onClick={props.updatebtn}
							className="far fa-edit pr-4"
						></i>
					) : (
						<FontAwesomeIcon
							icon={faFloppyDisk}
							className=" updateBtn emgContactUpdateBtn"
							onClick={props.updateEmgContact}
						/>
					)}
				</div>
			)}
			<Row className="personal-info-card">
				<Col lg={12}>
					{props.empInfo ? (
						<>
							<div className="row">
								<label className="formFieldsHeading my-1 col-12 col-sm-12 col-md-6 col-lg-4 col-form-label">
									Employee Name
								</label>
								<div className="formFieldsValues my-1 col-12 col-sm-12 col-md-6 col-lg-8">
									{props.employeeName}
								</div>
							</div>
							<div className="row">
								<label className="formFieldsHeading my-1 col-12 col-sm-12 col-md-6 col-lg-4 col-form-label">
									Employee Code
								</label>
								<div className="formFieldsValues my-1 col-12 col-sm-12 col-md-6 col-lg-8">
									{props.empCode}
								</div>
							</div>
							<div className="row">
								<label className="formFieldsHeading my-1 col-12 col-sm-12 col-md-6 col-lg-4 col-form-label">
									Department
								</label>
								<div className="formFieldsValues my-1 col-12 col-sm-12 col-md-6 col-lg-8">
									{props.empDepartment}
								</div>
							</div>
						</>
					) : (
						<div className="row">
							<label className="formFieldsHeading my-1 col-12 col-sm-12 col-md-6 col-lg-4 col-form-label">
								Contact Name
							</label>
							<div className="formFieldsValues my-1 col-12 col-sm-12 col-md-6 col-lg-7 p-0">
								{props.flag ? (
									<div className="update-contact">
										<Input
											type="text"
											name="empEmerContactName"
											onChange={
												props.updateContacthandleChange
											}
											className="updateEmergContact"
											value={
												props.updateEmergContact
													.empEmerContactName
											}
											isSearchable={false}
										/>
									</div>
								) : (
									<div className="formFieldsValues my-1 col-12 col-sm-12 col-md-8 col-lg-12 m-0">
										{props.empEmerContactName}
									</div>
								)}
							</div>
							<label className="formFieldsHeading my-1 col-12 col-sm-12 col-md-6 col-lg-4 col-form-label">
								Phone:
							</label>
							{props.flag ? (
								<div className="update-contact my-1 col-12 col-sm-12 col-md-6 col-lg-7 p-0">
									<Input
										type="text"
										name="empEmergContactPhone2"
										placeholder="1234-5678901"
										onChange={
											props.updateContacthandleChange
										}
										className="updateEmergContact"
										value={
											props.updateEmergContact
												.empEmergContactPhone2
										}
									/>
								</div>
							) : (
								<div className="formFieldsValues my-1 col-12 col-sm-12 col-md-6 col-lg-8">
									{props.empEmerContactPhone2}
								</div>
							)}
							<label className="formFieldsHeading my-1 col-12 col-sm-12 col-md-6 col-lg-4 col-form-label">
								Phone 2:
							</label>
							{props.flag ? (
								<div className="update-contact my-1 mt-2 col-12 col-sm-12 col-md-6 col-lg-7 p-0">
									<Input
										type="text"
										name="empEmergContactPhone1"
										placeholder="1234-5678901"
										onChange={
											props.updateContacthandleChange
										}
										className="updateEmergContact"
										value={
											props.updateEmergContact
												.empEmergContactPhone1
										}
									/>
								</div>
							) : (
								<div className="formFieldsValues my-1 col-12 col-sm-12 col-md-6 col-lg-8">
									{props.empEmerContactPhone1}
								</div>
							)}

							<label className="formFieldsHeading my-1 col-12 col-sm-12 col-md-6 col-lg-4 col-form-label">
								Address:
							</label>
							<div className="formFieldsValues my-1 col-12 col-sm-12 col-md-6 col-lg-7 p-0 address-textArea">
								{props.flag ? (
									<div className="update-contact">
										<Input
											type="textarea"
											className="updateEmergContact"
											name="empEmerContactAdd"
											onChange={
												props.updateContacthandleChange
											}
											value={
												props.updateEmergContact
													.empEmerContactAdd
											}
										>
											{
												props.updateEmergContact
													.empEmerContactAdd
											}
										</Input>
									</div>
								) : (
									<div className="formFieldsValues my-1 col-12 col-sm-12 col-md-6 col-lg-12">
										{props.empEmerContactAdd}
									</div>
								)}
							</div>
						</div>
					)}
				</Col>
			</Row>
		</div>
	);
};

export default Personalinfo;
